export enum StepsId {
  StudentEmailStep = 'StudentEmailStep',
  ConfirmCodeStep = 'ConfirmCodeStep'
}

export type GoToStepFn = (stepId: StepsId) => void;
